import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import BackupIcon from '@material-ui/icons/Backup';
import { useUploader } from "../../uploader/Uploader";
import { useTranslate } from "ra-core";

const FileUploadButton = (props) => {
    const { onClick } = props;
    const uploader = useUploader();
    const translate = useTranslate();
    const handleOnClick = () => {
        uploader.openFileUploadDialog();
        onClick();
    }
    return (
        <ListItem button onClick={handleOnClick}>
            <ListItemIcon>
                <BackupIcon/>
            </ListItemIcon>
            <ListItemText primary={translate(`cmss.resources.file-explorer.directory-actions-menu.buttons.upload-file`)} />
        </ListItem>
    )
};
export default FileUploadButton;